import {
  abweichenderRechnungsempfaengerPflichtfelderSchema,
  abweichenderRechnungsempfaengerSchema,
  AdresseFormValue,
  adressePflichtfelderSchema,
  adresseSchema,
  PrivatUnternehmenFormValue,
  privatUnternehmenKontaktdatenSchema,
  privatUnternehmenPflichtfelderSchema,
  RechnungsempfaengerFormValue,
  UnterschriftFormValue,
  VertragspartnerMode,
} from './common-vertragspartner.schema';
import { apply, applyWhen, applyWhenValue, Schema, schema } from '@angular/forms/signals';

export interface BisherigerVertragspartnerFormValue {
  vertragspartnerBekanntheit: 'known' | 'unknown';
  privatUnternehmen: PrivatUnternehmenFormValue;
  adresse: AdresseFormValue | null;
}

export interface BisherigerVertragspartnerStepFormValue extends UnterschriftFormValue {
  rechnungsempfaenger: RechnungsempfaengerFormValue;
  vertragspartner: BisherigerVertragspartnerFormValue;
}

export const bisherigerVertragspartnerSchema = schema<BisherigerVertragspartnerFormValue>(path => {
  apply(path.privatUnternehmen, privatUnternehmenKontaktdatenSchema);
  applyWhenValue(path.adresse, value => value !== null, adresseSchema);
});

export function bisherigerVertragspartnerStepSchema(mode: VertragspartnerMode): Schema<BisherigerVertragspartnerStepFormValue> {
  return schema<BisherigerVertragspartnerStepFormValue>(path => {
    switch (mode) {
      case VertragspartnerMode.BEARBEITBAR:
        apply(path.vertragspartner, bisherigerVertragspartnerSchema);
        break;
      case VertragspartnerMode.ACCOUNT_KUNDE:
        apply(path.rechnungsempfaenger, abweichenderRechnungsempfaengerSchema);
        break;
      case VertragspartnerMode.VERWALTETER_KUNDE:
        break;
    }
  });
}

/** Required fields of a known bisheriger Vertragspartner; an unknown one has no fields at all. */
export const bisherigerVertragspartnerPflichtfelderSchema = schema<BisherigerVertragspartnerFormValue>(path => {
  applyWhen(
    path,
    ctx => ctx.value().vertragspartnerBekanntheit === 'known',
    bekannterVertragspartnerPath => {
      apply(bekannterVertragspartnerPath.privatUnternehmen, privatUnternehmenPflichtfelderSchema);
      applyWhenValue(bekannterVertragspartnerPath.adresse, value => value !== null, adressePflichtfelderSchema);
    },
  );
});

/** Completion counterpart of {@link bisherigerVertragspartnerStepSchema}: what must be filled in before signing. */
export function bisherigerVertragspartnerStepPflichtfelderSchema(
  mode: VertragspartnerMode,
): Schema<BisherigerVertragspartnerStepFormValue> {
  return schema<BisherigerVertragspartnerStepFormValue>(path => {
    switch (mode) {
      case VertragspartnerMode.BEARBEITBAR:
        apply(path.vertragspartner, bisherigerVertragspartnerPflichtfelderSchema);
        break;
      case VertragspartnerMode.ACCOUNT_KUNDE:
        apply(path.rechnungsempfaenger, abweichenderRechnungsempfaengerPflichtfelderSchema);
        break;
      case VertragspartnerMode.VERWALTETER_KUNDE:
        break;
    }
  });
}
